import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import BookingFormLabel from '~/booking/components/BookingFormLabel/BookingFormLabel'

import { Product } from '~/types/product'

import ProductItem from './ProductItem'

export default function Products({
  includeTravelExpense,
  onClick,
  products,
  selectedProduct,
  showAllProducts,
}: {
  includeTravelExpense: boolean
  onClick: (product: Product) => void
  products: Product[]
  selectedProduct: Product | null
  showAllProducts: boolean
}): React.ReactElement {
  const { t } = useTranslation('booking')

  const sectionClasses = classNames('bg-pink-light p-4 rounded space-y-3', {
    'rounded-tr-none rounded-tl-none': !showAllProducts,
  })

  return (
    <section className={sectionClasses}>
      {showAllProducts && <BookingFormLabel>{t('tutoringPackages')}</BookingFormLabel>}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {products?.map((product) => {
          return (
            <ProductItem
              includeTravelExpense={includeTravelExpense}
              isSelected={selectedProduct?.id === product.id}
              key={product.id}
              onClick={onClick}
              product={product}
            />
          )
        })}
      </div>
    </section>
  )
}
